module.exports = {"532323101":"共和镇","532323102":"新桥镇","532323103":"江坡镇","532323104":"凤屯镇","532323201":"蟠猫乡","532323202":"戌街乡","532323203":"安乐乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532323.json
// module id = 2425
// module chunks = 0